import React, { useEffect, useCallback } from "react";
import "./map-select-brach.scss";
import defaultImg from "../../img/default.png";

const MapSelectBranch = props => {
	const { companies = [], dataCompanies, setDataCompanies } = props;

	let root = null;

	useEffect(() => {
		// Прокрутка до активного элемента
		const activeCompanies = companies.filter(company => company.isActive);
		if (activeCompanies && activeCompanies.length === 1) {
			const el = root.querySelector(`[id='${activeCompanies[0].id}']`);
			if (root && el) {
				root.scrollTop = el.offsetTop;
			}
		}
	}, [companies, root]);

	const selectCompany = useCallback(
		company => () => {
			setDataCompanies(
				dataCompanies.map(item => {
					if (item.id === company.id) {
						item.isActive = !item.isActive;
					}
					return item;
				})
			);
		},
		[setDataCompanies, dataCompanies]
	);

	return (
		<div className="map-select-branch">
			<div className="grid-container">
				<div className="row">
					<ul
						className="map-select-branch__list"
						ref={c => {
							root = c;
						}}
					>
						{companies &&
							companies.map(company => {
								const { name, url, id, isActive } = company;
								return (
									<li
										className={`${isActive ? "active" : ""} col-xs-12`}
										key={id}
										id={id}
										onClick={selectCompany(company)}
									>
										<img alt="" src={url || defaultImg} />
										{name}
									</li>
								);
							})}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default MapSelectBranch;
